import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import type AppConfig from '../domain/AppConfig';
import AppService from '../service/AppService';

let preload = ['ja'];
let locale = 'ja';
let appConfig:AppConfig = AppService.appConfig();
if (appConfig.langCode) {
  locale = appConfig.langCode;
  if (locale != 'ja') {
    preload.push(locale);
  }
}
const serverHost = AppService.serverHost();

i18n
  .use(XHR)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    fallbackLng: 'ja',
    fallbackNS: 'aw',
    defaultNS: 'aw',
    preload: ['ja'],
    ns: ['aw', 'catalog', 'application'],
    lng: locale,
    debug: false,
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: `${serverHost}/i18n/{{lng}}/{{ns}}.json`,
    }
  });

export default i18n;
